import styled from 'styled-components';

const Version = styled.span`
    color: #666;
`;

export default Version;
